import http from "./http";

export default {

  getBPMUsers(options,name,formType,token) {      
    let url=`/api/v1/MDM/GetAllBPMUsers/?env=${name}&formType=${formType}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },

  RemoveTempDirectory(options,guid,token){    
    let url=`/api/v1/MDM/RemovefromDirectory/?guid=${guid}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});  
  },

  //DeleteICRequest
  UpdateICRequestGUID(token,requestId,guid){    
    window.console.log(requestId);
    let url=`/api/v1/Clients/UpdateDraftRequestId/?DraftRequestId=${requestId}&Guid=${guid}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});  
  },

  getEntityRecords(options,name,token) {    
    let url=`/api/v1/MDM/GetEntity/?entityName=${name}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },

  getOriginalEntityRecords(options, name, isTimeOnly, token) {
    let url=`/api/v1/MDM/GetEntityAgency/?entityName=${name}`;
    if(name == "Financial Entity"){
      url=`/api/v1/Entity/GetAllEntities`;
      if(isTimeOnly == true){
        url= url + `?isTimeOnly=${isTimeOnly}`;
      }
    }    
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },

  getAgencyRecords(options,entityCode,token) {          
    let url=`/api/v1/Agency/GetEntityAgencies?entityCode=${entityCode}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },
  getAllAgencyRecords(options,token) {          
    let url=`/api/v1/MDM/GetAllEntityAgency?entityName=Agencies`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },
  
  GetCheckHFMCodeExists(options,name,token) {     
    window.console.log(JSON.stringify(name));     
    let url=`/api/v1/MDM/GetHFMCodeExists?hfmcode=${name.HFMCode}&referenceCode=${name.referenceCode}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },

  getDropdownList(name) {
    return http.get(`data/${name}`);
  },
  getPaymentTerms(options) {
    return http.get(`${options.endpoint}`
    ,{
      headers: {
      'Authorization': `Bearer ${options.token}`,
    }}
  );
  },
  getAgencyList() {
    return http.get(`/api/v1/MDM/LoadAgency`);
  },

  getAgencyNetworkRegion(options,name,token) {          
    let url=`/api/v1/MDM/GetAgencyNetworkRegion?entityName=${name}`;
    return http.get(url,{
      headers: {
      'Authorization': `Bearer ${token}`,
    }});
  },
  
};
